const app = {

	/**
	 * Initialize the app.
	 *
	 * @return {void}
	 */
	init: function() {

		const resetButton = document.getElementById( 'reset' );
		resetButton.addEventListener( 'click', app.clickReset );

		const colorButton = document.getElementById( 'change-colour' );
		colorButton.addEventListener( 'click', app.clickChangeColour );

		// const sizeButton = document.getElementById( 'change-size' );
		// sizeButton.addEventListener( 'click', app.clickChangeSize );

		const artSizeButton = document.getElementById( 'change-size-art' );
		artSizeButton.addEventListener( 'click', app.clickChangeSizeArt );

		const undoButton = document.getElementById( 'undo' );
		undoButton.addEventListener( 'click', undo.undo );

		const redoButton = document.getElementById( 'redo' );
		redoButton.addEventListener( 'click', undo.redo );

		document.addEventListener(
			'reef-set-data',
			() => {
				app.updateButtons();
			}
		);

		setTimeout( app.updateButtons, 1000 );

	},


	/**
	 * Change the background color.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	clickChangeColour: function( e ) {

		e.preventDefault();

		let currentPalette = parseInt( ninjaData.data.backgroundColor );

		currentPalette++;
		if ( 'transparent' === settingsPalette[ currentPalette ] ) {
			currentPalette++;
		}
		if ( currentPalette >= settingsPalette.length ) {
			currentPalette = 0;
		}

		ninjaData.setData(
			{
				backgroundColor: currentPalette,
			}
		);

		app.updateButtons();

	},


	/**
	 * Update the button colours.
	 *
	 * @return {void}
	 */
	updateButtons: function() {

		// Background Colour.
		const bgButton = document.getElementById( 'change-colour' );

		if ( bgButton ) {

			const currentPalette = parseInt( ninjaData.data.backgroundColor );

			bgButton.style.backgroundColor = settingsPalette[ currentPalette ];
			bgButton.style.color = tinycolor.mostReadable( settingsPalette[ currentPalette ], [ '#000', '#fff' ] );

		}

		// Drawing Size.
		// const sizeButton = document.getElementById( 'change-size-art' );

		// if ( sizeButton ) {
		// 	const currentSize = artSize[ ninjaData.data.currentArtSize ];
		// 	sizeButton.textContent = `Size [${currentSize} x ${currentSize}]`;
		// }

	},


	/**
	 * Reset the artwork to be the defaults.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	clickReset: function( e ) {

		e.preventDefault();

		ninjaData.setData(
			{
				art: defaultEmojiArt( ninjaData.data.currentArtSize ),
			}
		);

		undo.reset();

	},


	/**
	 * Change the frame shape and size.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	clickChangeSize: function( e ) {

		e.preventDefault();

		const current = ninjaData.data.size;
		const keyList = Object.keys( dimensions );

		let keyId = keyList.findIndex(
			( value ) => {
				return value === current;
			}
		);

		keyId++;
		if ( keyId >= keyList.length ) {
			keyId = 0;
		}

		ninjaData.setData(
			{
				size: keyList[ keyId ],
			}
		);

		undo.reset();

	},


	/**
	 * Change the amount of emojis to use.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	clickChangeSizeArt: function( e ) {

		e.preventDefault();

		let newArtSize = ninjaData.data.currentArtSize + 1;
		if ( newArtSize >= artSize.length ) {
			newArtSize = 0;
		}

		// Make sure we don't try to copy more than the new size.
		let oldSize = Math.min( artSize[ ninjaData.data.currentArtSize ], artSize[ newArtSize ] );

		let newArt = defaultEmojiArt( newArtSize );
		const art = ninjaData.data.art;

		// Copy the old art to the new art so we lose as little as possible.
		for ( let y = 0; y < oldSize; y++ ) {
			for ( let x = 0; x < oldSize; x++ ) {
				newArt[ y ][ x ] = art[ y ][ x ] + '';
			}
		}

		// Update the data.
		ninjaData.setData(
			{
				height: artSize[ newArtSize ],
				width: artSize[ newArtSize ],
				art: newArt,
				currentArtSize: newArtSize,
			}
		);

		undo.reset();

	},

};